'use client';

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface BackButtonProps {
  onClick?: () => void;
  variant?: 'default' | 'dark' | 'white';
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  variant = 'default',
  className,
}) => {
  const getIconColor = () => {
    switch (variant) {
      case 'dark':
        return 'text-gray-900';
      case 'white':
        return 'text-white';
      default:
        return 'text-gray-900';
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      className={cn(
        'cursor-pointer p-2 rounded-full hover:bg-gray-100 transition-colors relative z-10',
        variant === 'white' && 'hover:bg-white/20',
        variant === 'dark' && 'hover:bg-gray-200',
        className,
      )}
      style={{ minWidth: '40px', minHeight: '40px' }}
    >
      <ArrowLeft size={24} className={cn('h-6 w-6', getIconColor())} />
    </div>
  );
};
